<script lang="ts" setup>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCartShopping } from '@fortawesome/free-solid-svg-icons'
library.add(faCartShopping)
</script>
<template>
  <FontAwesomeIcon icon="fa-solid fa-cart-shopping" />
</template>
